import { render, staticRenderFns } from "./EditTwoPhaseMethod.vue?vue&type=template&id=6bb03b94&scoped=true"
import script from "./EditTwoPhaseMethod.vue?vue&type=script&lang=js"
export * from "./EditTwoPhaseMethod.vue?vue&type=script&lang=js"
import style0 from "./EditTwoPhaseMethod.vue?vue&type=style&index=0&id=6bb03b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb03b94",
  null
  
)

export default component.exports